import React, { useState, useEffect } from 'react';
import { BiPlus, BiX } from 'react-icons/bi';
import Header from '../../component/Header';

const JobNotificationRegister = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedIndustries, setSelectedIndustries] = useState([]);
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', location: '' });
  const [paystackLoaded, setPaystackLoaded] = useState(false);
  const industries = [
    "Healthcare", "Technology", "Finance", "Education", "Retail", "Manufacturing",
    "Construction", "Hospitality", "Transportation and Logistics", "Real Estate",
    "Legal", "Energy", "Telecommunications", "Media and Entertainment", "Agriculture",
    "Government", "Non-Profit", "Aerospace"
  ];

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.paystack.co/v1/inline.js';
    script.async = true;
    script.onload = () => setPaystackLoaded(true);
    script.onerror = () => console.error('Failed to load Paystack script');
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script); // Cleanup on unmount
    };
  }, []);

  const handleIndustrySelect = (industry) => {
    setSelectedIndustries(prev =>
      prev.includes(industry) ? prev.filter(i => i !== industry) : [...prev, industry]
    );
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRegister = () => {
    if (selectedIndustries.length === 0) {
      alert('Please select at least one industry');
      return;
    }
    setIsModalOpen(true);
  };

  const handleSubmit = () => {
    if (!formData.name || !formData.email || !formData.phone || !formData.location) {
      alert('Please fill all fields');
      return;
    }
    payWithPaystack();
  };

  const payWithPaystack = () => {
    if (!paystackLoaded) {
      alert('Paystack is loading or failed to load. Please try again or check your connection.');
      return;
    }
    const handler = window.PaystackPop.setup({
      key: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY,
      email: formData.email,
      amount: 3000 * 100,
      currency: 'NGN',
      ref: `JOB_NOTIF_${Date.now()}`,
      callback: (response) => {
        fetch(`${process.env.REACT_APP_API_URL}subscribe`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ...formData, industries: selectedIndustries, paymentRef: response.reference, amount: 3000 }),
        })
          .then(res => res.json())
          .then(data => {
            if (data.success) {
              alert('Subscription successful! Job notifications will be sent to your email.');
              setIsModalOpen(false);
            } else {
              alert('Subscription failed. Please contact support.');
            }
          })
          .catch(err => console.error('Error:', err));
      },
      onClose: () => {
        alert('Payment cancelled.');
      },
    });
    handler.openIframe();
  };

  return (
    <>
    <Header/>
   <div className="min-h-screen mt-20 bg-gray-100 p-6">
      <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">Job Notification Subscription</h2>
      <div className="max-w-2xl mx-auto bg-white p-6 rounded-lg shadow-lg">
        <h3 className="text-xl font-semibold text-gray-700 mb-4">Select Job Industries</h3>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
          {industries.map(industry => (
            <button
              key={industry}
              onClick={() => handleIndustrySelect(industry)}
              className={`px-4 py-2 rounded-lg text-white transition-colors ${
                selectedIndustries.includes(industry)
                  ? 'bg-blue-600 hover:bg-blue-700'
                  : 'bg-gray-400 hover:bg-gray-500'
              }`}
            >
              {industry}
            </button>
          ))}
        </div>
        <button
          onClick={handleRegister}
          disabled={selectedIndustries.length === 0}
          className="w-full bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors flex items-center justify-center gap-2 disabled:bg-gray-400 disabled:cursor-not-allowed"
        >
          <BiPlus /> Register for Notifications
        </button>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold">Registration Details</h3>
              <button onClick={() => setIsModalOpen(false)} className="text-gray-500 hover:text-gray-700">
                <BiX size={24} />
              </button>
            </div>
            <form className="space-y-4">
              <input
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Full Name"
                required
                className="w-full p-2 border rounded"
              />
              <input
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Email"
                required
                className="w-full p-2 border rounded"
              />
              <input
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="Phone Number"
                required
                className="w-full p-2 border rounded"
              />
              <input
                name="location"
                value={formData.location}
                onChange={handleInputChange}
                placeholder="Location"
                required
                className="w-full p-2 border rounded"
              />
              <button
                type="button"
                onClick={handleSubmit}
                className="w-full bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
              >
                Submit & Pay ₦3,000
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
    </>
 
  );
};

export default JobNotificationRegister;